/* istanbul ignore file */
import { ArrivalService } from 'core/analytics/interfaces';

export class ArrivalServerService implements ArrivalService {
  trackArrival() {}
}
